import React from "react";
import InnerHaeder from "../Component/InnerHaeder";
import Highlights from "../Component/Highlights";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
import HeadTag from "../Component/HeadTags";
import LazyLoad from "react-lazyload";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
const ArtCraft = () => {
  return (
    <>
      <HeadTag title="Art & Craft" />
      <Highlights />
      <InnerHaeder />
      <div className="inner_page">
        <div className="container-fluid flwidth  accordionDef">
          <div className="bgimage">
            <h5>
              <Link to="/">
                {" "}
                Home <i className="fas fa-angle-right"></i>{" "}
              </Link>
              <span>
                {" "}
                Admission <i className="fas fa-angle-right"></i> Art &
                Craft{" "}
              </span>
            </h5>
            <h2> Art & Craft</h2>
          </div>
          <Tabs className="Tabs">
            <TabList>
              <Tab>2026 </Tab>
              <Tab>2025</Tab>
            </TabList>
            <TabPanel>
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id="2026"
                  >
                    <button
                      class="accordion-button collapsed show"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#trainerrjan-collapseAgeCareer10"
                      aria-expanded="false"
                      aria-controls="trainerrjan-collapseAgeCareer10"
                    >
                      2026
                    </button>
                  </h2>
                  <div
                    id="trainerrjan-collapseAgeCareer10"
                    class="accordion-collapse collapse show"
                    aria-labelledby="2026">
                    <div class="accordion-body">
                      <div className="row">
                        <div className="col-lg-12">
                          {/* <h3>
                            Moving Forward by 1°: A Paradigm Shift in
                            Professional Excellence
                          </h3> */}
                          <p>We are proud to announce that our talented students have brought laurels to the school by excelling in the International Art Competition 2025–26 organized by Rangotsav Celebration. Their creativity, dedication, and artistic brilliance have truly made us proud on an international platform. Heartiest Congratulations to our Winners: Ziya Usmani – 1st Prize (Caricature Competition) Gia Aggarwal – 2nd Prize (Caricature Competition) Nitya Baliyan – 3rd Prize (Sketching Competition) Shubhreet Kaur – Trophy (Sketching Competition) Ritshja Jaiswal – Trophy (Sketching Competition) Aadish Biala – Medal (Cartoon Making Competition) Anshik – Consolation Prize (Sketching Competition) A special appreciation to their mentor Ms. Anushka Rathour for her constant guidance, encouragement, and dedication in nurturing young artists.</p>
                        </div>
                        <div className="col-lg-12 col-md-12">
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/art-26.jpg"
                          >
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/art-26.jpg"
                                className="art_craft_img img-fluid mx-auto d-block"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div class="accordion accordion-flush" id="accordionFlushExample">
                <div class="accordion-item">
                  <h2
                    class="accordion-header"
                    id="2025"
                  >
                    <button
                      class="accordion-button collapsed show"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#2025"
                      aria-expanded="false"
                      aria-controls="2025"
                    >
                      2025
                    </button>
                  </h2>
                  <div
                    id="trainermay-collapseAgeCareer9"
                    class="accordion-collapse collapse show"
                    aria-labelledby="2025"
                  >
                    <div class="accordion-body">


                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <h3 className="text-center">
                            "A work of art is above all an adventure of the mind."
                          </h3>
                          <a
                            data-magnify="gallery"
                            data-src=""
                            data-group="a"
                            href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/art.jpg"
                          >
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/art.jpg"
                                className="art_craft_img img-fluid mx-auto d-block"
                                alt="Lotus Valley International School, Greater Noida"
                              />
                            </LazyLoad>
                          </a>
                        </div>
                      </div>
                      <h3>
                        <center>
                          <b>REPORT - 2025 </b>
                        </center>
                      </h3>
                      <div className="row acheivement_2024">
                        <div className="col-md-12">
                          <h3>GRAFFITI ART EXPRESSION</h3>
                          <p>
                            We are delighted to share yet another proud moment of
                            achievement by our talented students! Our students secured First
                            Position at Sapphire International School, Sector 70, Noida, in
                            the event themed ‘WALLFLORA – A GRAFFITI ART EXPRESSION’.{" "}
                          </p>
                          <p>
                            Winners:
                            <br /> 1. Ziya Usmani (XII Mozart) 2. Sunishka Agarwal (XII
                            Bhatkhande) 3. Gia Agarwal (XII Tansen) 4. Ridhi Sareen (XII
                            Tansen) <br />
                            Mentor: Ms. Anushka Rathour
                          </p>
                          <p>
                            Congratulations to the winners and their mentor for this
                            creative triumph!
                          </p>
                        </div>
                        <div className="col-md-4">
                          <div className="img-block">
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/graffiti1.jpg"
                                className="img-fluid"
                                alt="Graffiti1"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="img-block">
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/graffiti2.jpg"
                                className="img-fluid"
                                alt="Graffiti2"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="img-block">
                            <LazyLoad>
                              <img
                                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGN/public/Images/graffiti3.jpg"
                                className="img-fluid"
                                alt="Graffiti3"
                              />
                            </LazyLoad>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Tabs>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ArtCraft;
